import * as yup from "yup";

export const createBankFormatSchema = yup.object().shape({
  name: yup.string().required(),
  country: yup.object({ text: yup.string(), value: yup.string() }).required(),
});
